var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightbulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: props.fill,
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45 21.75a.8.8 0 01.8-.8h7.5a.8.8 0 010 1.6h-7.5a.8.8 0 01-.8-.8zM15.788 4.224a6.7 6.7 0 00-3.95-1.172C8.211 3.137 5.28 6.158 5.3 9.788a6.69 6.69 0 002.57 5.239l-.492.63.492-.631a3.06 3.06 0 011.18 2.409v.515h5.9v-.52a3.077 3.077 0 011.19-2.412 6.7 6.7 0 00-.352-10.794zM7.45 17.436a1.46 1.46 0 00-.563-1.147l.491-.632-.492.63A8.287 8.287 0 013.7 9.798c-.025-4.501 3.6-8.238 8.1-8.345a8.302 8.302 0 015.327 14.826l-.005.003a1.477 1.477 0 00-.572 1.157V18A1.55 1.55 0 0115 19.55H9A1.55 1.55 0 017.45 18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.973 5.19a.8.8 0 01.922-.655 5.293 5.293 0 014.33 4.324.8.8 0 11-1.577.27 3.693 3.693 0 00-3.02-3.017.8.8 0 01-.655-.923z"
  }))));
}

export default SvgLightbulb;